const initialState = {
  workers: { data: [] },
  all_employees: [],
  fullworks: { data: [] },
};

export const worker_reducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_EMPLOYEE":
      return {
        ...state,
        workers: [...state.workers, action.payload],
      };
    case "GET_EMPLOYEES":
      return {
        ...state,
        workers: action.payload,
      };
    case "GET_ATTENDENCE":
      return {
        ...state,
        fullworks: action.payload,
      };
    case "DELETE_EMPLOYEE":
      return {
        ...state,
        workers: {
          ...state.workers,
          data: state.workers.data.filter((li) => li.id !== action.payload),
        },
      };
    case "GET_ALL_EMPLOYEES":
      return {
        ...state,
        all_employees: action.payload,
      };
    default:
      return state;
  }
};
